module.exports = __webpack_public_path__ + "img/14.d4ad3c48.png";